import format from 'date-fns/format';
import getYear from 'date-fns/getYear';
import { User } from '@adsk/alloy-provider';
import { changeTimeZone, EnumDropdownOption, formatFilterDateRange } from '../../../../../helpers';
import { Assignee } from '../../../../../sdk';
import { Filters, FiltersKeysUnion } from '../../FiltersPanelTypes';
import { DateRange } from '../../../../../components/DatePicker/helpers/rangeHelpers';

const MAX_VALUE_YEAR = 9999;
const MIN_VALUE_YEAR = 1970;
export const MAX_VALUE_DATE = `${MAX_VALUE_YEAR}-02-02`;
export const MIN_VALUE_DATE = `${MIN_VALUE_YEAR}-02-02`;

export const getStartEndDateFromFilter = (dateRange?: string | null, timeZone = 'UTC') => {
  if (!dateRange) {
    return { startDate: null, endDate: null };
  }

  const [startUtcIsoString, endUtcIsoString] = dateRange.split(',');
  const convertedStartDate = changeTimeZone(startUtcIsoString, timeZone);
  const convertedEndDate = changeTimeZone(endUtcIsoString, timeZone);

  const endDate = getYear(convertedEndDate) < MAX_VALUE_YEAR ? convertedEndDate : null;

  const startDate = getYear(convertedStartDate) > MIN_VALUE_YEAR ? convertedStartDate : null;

  return { startDate, endDate };
};

export const updateFilterDateField =
  ({
    key,
    updateFilters,
    timeZone = 'UTC',
  }: {
    key: keyof Pick<Filters, 'dueDate' | 'createdAt'>;
    updateFilters: (key: FiltersKeysUnion, value: string | null) => void;
    timeZone?: string;
  }) =>
  (change: Date | DateRange | null | undefined) => {
    if (!change || !Array.isArray(change)) {
      updateFilters(key, null);
      return;
    }
    const [start, end] = change;
    if (start || end) {
      const startDate = start ? format(start, 'yyyy-MM-dd') : MIN_VALUE_DATE;
      const endDate = end ? format(end, 'yyyy-MM-dd') : MAX_VALUE_DATE;

      const dateRangeString = formatFilterDateRange({
        startDate,
        endDate,
        timeZone,
      });

      updateFilters(key, dateRangeString);
    } else {
      updateFilters(key, null);
    }
  };

export const getEnumSelectedOptions = (
  values: string[] | string,
  options: EnumDropdownOption[],
) => {
  const asArray = Array.isArray(values) ? values : [values];
  return options.filter(({ key }) => asArray.includes(key));
};

export const getUpdateFilters = (options?: EnumDropdownOption[]) =>
  options ? options.map(({ key }) => ({ value: key })) : [];

export const getMultipleSelectFilter = (options?: Assignee[]) => options || [];

export const filterUsersArray = (users: User[]) => users.filter((user) => !!user.name);

export const sortAlphabeticallyByName = (arr: User[]) => {
  const sortedArray = [...arr];

  return sortedArray.sort((a, b) => {
    const valueA = (a?.name ? a.name : '').toUpperCase();
    const valueB = (b?.name ? b.name : '').toUpperCase();
    if (valueA < valueB) {
      return -1;
    }
    if (valueA > valueB) {
      return 1;
    }
    return 0;
  });
};

export const getDropdownOptionValues = <K extends { value: unknown }, T>(options: K[]) =>
  options.map(({ value }) => value as T);
